/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useTranslations } from '@/hooks/useTranslations';
import Review from '@/components/Review';
import { Navigate, useParams } from 'react-router-dom';
import { FlexBox, Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { useGetProductByFlowIdQuery } from '@/store/apis';

const ViewReportPage: React.FC = () => {
    const { t } = useTranslations();
    const { runId, flowId } = useParams();
    const { data } = useGetProductByFlowIdQuery(flowId as string, {
        skip: !flowId,
    });
    const { taskQueryError, phases } = Review.useReviewData(runId as string);

    if (taskQueryError) {
        console.error('Error loading taskQuery:', taskQueryError);
        return <Navigate to="/" />;
    }

    if (!phases.length) {
        return null;
    }

    return (
        <FlexBox direction="Column" style={{ backgroundColor: ThemingParameters.sapBaseColor }}>
            <FlexBox
                direction="Column"
                gap={ThemingParameters.sapContent_Padding_M}
                style={{
                    padding: `${ThemingParameters.sapContent_Padding_M} 0`,
                }}
                alignItems="Center"
            >
                <Title style={{ fontSize: ThemingParameters.sapFontHeader3Size, textAlign: 'center' }} level="H3">
                    {data && t('SKU_SET_UP_DETAILS', data.name)}
                </Title>

                <div
                    style={{
                        width: '100%',
                        padding: '0 2rem',
                    }}
                >
                    {phases.map((phase, i) => (
                        <Review.PhaseItem key={phase.id} data={phase} order={i + 1} isEditable={false} />
                    ))}
                </div>
            </FlexBox>
        </FlexBox>
    );
};


export default ViewReportPage;
